module.exports = __webpack_public_path__ + "img/integral_img.378bf17d.png";